import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Alert from 'src/components/alert';
import useMediaQuery from 'src/hooks/useMediaQuery';

const DocumentParserWarning = () => {
  const isMobileView = useMediaQuery('(min-width: 300px) and (max-width: 600px)');
  const [expanded, setExpanded] = useState(false);

  const tooltipText = (
    <span>
      You&apos;re uploading a document that will be manually parsed for each piece. Only upload at
      the instruction group level if the content is relevant to every piece in the group. If the
      document only applies to specific pieces, upload it directly to those pieces instead.
    </span>
  );

  const toggleExpanded = () => setExpanded(prev => !prev);

  return (
    <Alert name='document_upload' variant='warning' className='text-left mt15 mb-0'>
      <div className='d-flex align-items-center justify-content-center'>
        <OverlayTrigger
          placement='bottom'
          overlay={
            <Tooltip id='document_upload_warning' className='work-instruction-tooltip'>
              {tooltipText}
            </Tooltip>
          }
        >
          <FontAwesomeIcon icon={faTriangleExclamation} color='#FF9903' className='spacer-right' />
        </OverlayTrigger>
        <h4 className='mb-0' style={{ fontSize: '0.9rem' }}>
          Parsing Document Upload Warning
        </h4>
      </div>
      {isMobileView && (
        <div>
          <Button variant='default' className='show-more-btn' onClick={toggleExpanded}>
            Show {expanded ? 'less' : 'more'}
          </Button>

          {expanded && <div className='parser-warning-text'>{tooltipText}</div>}
        </div>
      )}
    </Alert>
  );
};

export default DocumentParserWarning;
